import axios from 'axios';
import { vue } from '../../app';
import store from "../store/store";
import Errors from "../components/Includes/ErrorComponent/Errors";


const baseURL = process.env.MIX_APP_URL;

const axiosInstance = axios.create({
    baseURL: baseURL + '/api',
});

/*
  Request Interceptor
 */
axiosInstance.interceptors.request.use((config) => {
    //  Generate cancel token source
    let source = axios.CancelToken.source();

    // Set cancel token on this request
    config.cancelToken = source.token;

    // Add to vuex to make cancellation available from anywhere
    store.commit('ADD_CANCEL_TOKEN', source);

    config.headers = {
        //'Authorization': 'Bearer ' + accessToken,
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }

    config.withCredentials = true;

    let loadingType =  'content';
    if(typeof config.fullPageLoading !== 'undefined') {
        if(config.fullPageLoading) {
            loadingType = 'full_page';
        }
    }
    if(typeof config.localLoading !== 'undefined') {
        if(config.localLoading) {
            loadingType = 'local';
        }
    }

    let hideProgressBar = false;
    if(typeof config.hide_progress_bar !== 'undefined')
        hideProgressBar = true;

    if(store.state.loading.content === 0 && store.state.loading.full_page === 0 && store.state.loading.local === 0){
        if(!hideProgressBar)
            vue.$Progress.start();
    }

    if(typeof config.dont_append_to_loading_stack === 'undefined')
        store.commit('addRequestToLoadingStack', loadingType);


    if (typeof config.dontFlushErrors === 'undefined')
        Errors.flush();

    return config;
}, error => {
    Promise.reject(error)
});


/*
  Response Interceptor
 */
axiosInstance.interceptors.response.use((response) => {
    if(typeof response.data !== 'undefined') {
        if(typeof response.data.message !== 'undefined') {
            vue.$snotify.success(response.data.message);
        }
    }

    let loadingType =  'content';
    if(typeof response.config.fullPageLoading !== 'undefined') {
        if(response.config.fullPageLoading) {
            loadingType = 'full_page';
        }
    }
    if(typeof response.config.localLoading !== 'undefined') {
        if(response.config.localLoading) {
            loadingType = 'local';
        }
    }

    if(typeof response.config.dont_append_to_loading_stack === 'undefined')
        store.commit('removeRequestFromLoadingStack', loadingType);

    let hideProgressBar = false;
    if(typeof response.config.hide_progress_bar !== 'undefined')
        hideProgressBar = true;

    vue.$nextTick(() => {
        if(store.state.loading.content === 0 && store.state.loading.full_page === 0 && store.state.loading.local === 0){
            if(!hideProgressBar)
                vue.$Progress.finish();
        }
    });

    return response;
}, (error) => {
    let loadingType =  'content';

    if(typeof error?.config !== 'undefined') {
        if(typeof error.config.fullPageLoading !== 'undefined') {
            if(error.config.fullPageLoading) {
                loadingType = 'full_page';
            }
        }
        if(typeof error.config.localLoading !== 'undefined') {
            if(error.config.localLoading) {
                loadingType = 'local';
            }
        }
        if(typeof error.config.dont_append_to_loading_stack === 'undefined')
            store.commit('removeRequestFromLoadingStack', loadingType);

        let hideProgressBar = false;
        if(typeof error.config.hide_progress_bar !== 'undefined')
            hideProgressBar = true;

        vue.$nextTick(() => {
            if(store.state.loading.content === 0 && store.state.loading.full_page === 0 && store.state.loading.local === 0){
                if(!hideProgressBar)
                    vue.$Progress.fail();
            }
        });

        // if (error.response === undefined) {
        //     vue.$snotify.error("The server did not return any response. Please check your internet connection.");
        //     return Promise.reject(error);
        // }
        //

        if(typeof error.response.data !== 'undefined') {
            if(typeof error.response.data.error !== 'undefined') {
                vue.$snotify.error(error.response.data.error);
            }
        }

        switch(error.response.status) {
            case 400:
                return Promise.reject(error);
            case 401:
                if (vue.$store.getters.isAuthenticated) {
                    vue.$store.dispatch('logout')
                        .finally(() => {
                            //vue.$snotify.error("Your session has expired. Please log in again.");
                            vue.$router.push({name: 'login'});
                        });
                }
                break;
            case 422:
                Errors.fill(error.response.data.errors)
                vue.$snotify.error(error.response.data.message)
                break;
            case 404:
                if(vue.$store.getters.isAdmin) {
                    vue.$snotify.error(vue.$t('errors.404.resource_not_found'));
                } else {
                    vue.$router.push({name: 'error-404'})
                }
                break;
            case 500:
                if(error.response.data?.message !== undefined) {
                    vue.$snotify.error(error.response.data.message);
                }
                break;
        }
    }

    return Promise.reject(error);
});

export default axiosInstance;
